import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { BreedSearchResultPropTypes } from 'dpl/shared/utils/customPropTypes';
import SearchNoResults from 'dpl/components/Search/SearchNoResults';
import BreedSearchResultItem from 'dpl/components/BreedSearch/BreedSearchResultItem';

import { BREED_TYPES, ORDERED_BREED_TYPES, getBreedsForQuery, getGroupedBreeds } from './util';

export default class BreedSearchResultsList extends Component {
  static propTypes = {
    query: PropTypes.string,
    /* eslint-disable-next-line react/no-unused-prop-types */
    breeds: PropTypes.arrayOf(PropTypes.shape(BreedSearchResultPropTypes)).isRequired,
    inDropdown: PropTypes.bool,
    breedType: PropTypes.oneOf(ORDERED_BREED_TYPES)
  };

  static defaultProps = {
    query: '',
    breedType: null,
    inDropdown: false
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { breeds, query } = nextProps;
    const groupedBreeds = getGroupedBreeds(breeds, query);
    const selectedType = nextProps.breedType || prevState.selectedType;

    return {
      selectedType,
      breeds,
      groupedBreeds,
      filteredBreeds: groupedBreeds[selectedType] || []
    };
  }

  state = {
    selectedType: this.props.breedType || ORDERED_BREED_TYPES[0],
    /* eslint-disable-next-line react/no-unused-state */
    breeds: [],
    groupedBreeds: {},
    filteredBreeds: []
  };

  breedTypeManagedByParent = this.props.breedType !== null;

  handleTypeChange = (type) => {
    this.setState({
      selectedType: type,
      filteredBreeds: getBreedsForQuery(
        this.state.groupedBreeds[type],
        this.props.query
      )
    });
  };

  render() {
    const { query, inDropdown } = this.props;
    const { filteredBreeds, selectedType } = this.state;

    return (
      <div className="BreedSearchResultsList">
        {
          !this.breedTypeManagedByParent &&
            <div className="flex pv4-md pv2">
              {
                ORDERED_BREED_TYPES.map(type => (
                  <button
                    key={ type }
                    onClick={ () => this.handleTypeChange(type) }
                    type="button"
                    className={ classnames('pv1 ph4 f4-md', {
                      purple: selectedType !== type,
                      'bg-purple br1 white': selectedType === type
                    }) }
                  >
                    { type }
                  </button>
                ))
              }
            </div>
        }
        {
          filteredBreeds.length === 0 ? (
            <SearchNoResults query={ query } />
          ) : (
            <Fragment>
              {
                filteredBreeds.map((breed, idx) => {
                  const showTitle = idx === 0 ||
                    breed.hybrid !== filteredBreeds[idx - 1].hybrid;

                  const {
                    cover_photo_url: coverPhotoUrl,
                    name,
                    non_standard: hasNonStandard,
                    non_standard_cover_photo_url: nonStandardCoverPhotoUrl,
                    url: standardUrl,
                    live
                  } = breed;

                  const nonStandardUrl = `${standardUrl}/non-standard`;

                  return [
                    <div key={ standardUrl }>
                      {
                        showTitle &&
                          <p className="mv3 fw-medium">
                            { breed.hybrid ? BREED_TYPES.CROSSBRED : BREED_TYPES.PUREBRED }
                          </p>
                      }
                      <BreedSearchResultItem
                        coverPhotoUrl={ coverPhotoUrl }
                        inDropdown={ inDropdown }
                        live={ live }
                        name={ name }
                        url={ standardUrl }
                      />
                    </div>,
                    hasNonStandard && query && (
                      <div key={ nonStandardUrl }>
                        <BreedSearchResultItem
                          coverPhotoUrl={ nonStandardCoverPhotoUrl }
                          inDropdown={ inDropdown }
                          live={ live }
                          name={ `${name} (Non-standard)` }
                          url={ nonStandardUrl }
                        />
                      </div>
                    )
                  ];
                })
              }
            </Fragment>
          )
        }
      </div>
    );
  }
}
